import * as angular from "angular";
import * as _ from "lodash";
import {PricePlanRequestsService} from "./price-plan-requests.service";
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {PricePlanAlertsService} from "./price-plan-alerts.service";
import {PricePlanBundleRequestsService} from "./price-plan-bundle-requests.service";

export class PricePlanService {
  constructor(private pricePlanRequestsService: PricePlanRequestsService, private pricePlanBundleRequestsService: PricePlanBundleRequestsService, private pricePlanAlertsService: PricePlanAlertsService,
              private bringozLoaderService: BringozLoaderService, private $q: IQService, private $log) {
  }

  getTemplatesByType(type) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pricePlanRequestsService.getTemplatesByType(type)
      .then((templates) => {
        deferred.resolve(templates);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  createTemplate(type, name) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pricePlanRequestsService.createTemplate(type, name)
      .then((template) => {
        deferred.resolve(template);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updateProgramTemplate(programId, templateId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pricePlanRequestsService.updateProgramTemplate(programId, templateId)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getProgramPreferencesByGroups(pricePlanId, groups, accountId) {
    this.bringozLoaderService.on();
    return this.pricePlanRequestsService.getPricePlanPreferences(pricePlanId, groups, accountId)
      .then((preferences) => {
        return this.$q.when(preferences);
      })
      .catch((error) => {

      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  saveProgramDataByGroups(programId, program, groups, accountId) {
    const deferred = this.$q.defer<any>();

    this.bringozLoaderService.on();
    this.pricePlanRequestsService.savePricePlanPreferences(programId, accountId, program, groups)
      .then((updatedProgram) => {
        this.pricePlanAlertsService.updatePreferencesSuccess();
        deferred.resolve(updatedProgram);
      })
      .catch((error) => {
        this.$log.error(error);
        this.pricePlanAlertsService.updatePreferencesError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  generatePreferencesDataGroupKeys(groups) {
    let groupKeys = {};

    _.forEach(groups, (group) => {
      _.set(groupKeys, group.id, {});
      _.forEach(group.value, (field) => {
        _.set(groupKeys[group.id], field.id, field);
      });
    });

    return groupKeys;
  }

  generatePreferencesDataPayload(program, groupKeys) {
    _.forEach(program.data, (group) => {
      group.value = _.map(groupKeys[group.id]);
    });
    return program;
  }

  getSubTaskGroupsByIds(ids) {
    return _.map(ids, (id) => {
      return {
        type: "SubTasks",
        group: "SubTasks",
        value: {
          id: id,
          isEnabled: true,
          isDefault: false
        },
        id: id
      }
    });
  }

  getAdditionsGroups(additions) {
    return _.map(additions, (a) => {
      const additionRef = angular.copy(a);
      additionRef.enabled = true;
      return {
        type: "Addition",
        group: "Addition",
        value: additionRef,
        id: a.id
      }
    });
  }

  setSiteServiceProgramType(serviceType, programId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pricePlanBundleRequestsService.setSiteServiceProgramType(serviceType, programId)
      .then((updatedProgram) => {
        this.pricePlanAlertsService.updatePreferencesSuccess();
        deferred.resolve(updatedProgram);
      })
      .catch((error) => {
        this.$log.error(error);
        this.pricePlanAlertsService.updatePreferencesError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getSiteAdditions(ids) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pricePlanBundleRequestsService.getSiteAdditions(ids)
      .then((updatedProgram) => {
        deferred.resolve(updatedProgram);
      })
      .catch((error) => {
        this.$log.error(error);
        this.pricePlanAlertsService.getAdditionError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getProgramData(pricePlanId, accountId?, fromData?, toData?, allLocations?) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pricePlanRequestsService.getProgramData(pricePlanId, accountId, fromData, toData, allLocations)
      .then((programData) => {
        deferred.resolve(programData);
      })
      .catch((error) => {
        this.$log.error(error);
        this.pricePlanAlertsService.updatePreferencesError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  editProgramConfiguration(pricePlanId, payload, accountId?) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pricePlanRequestsService.editProgramConfiguration(pricePlanId, payload, accountId)
      .then((programData) => {
        this.pricePlanAlertsService.updatePreferencesSuccess();
        deferred.resolve(programData);
      })
      .catch((error) => {
        this.$log.error(error);
        this.pricePlanAlertsService.updatePreferencesError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  deleteRelationPricePlanPreferences(pricePlanId, fromId?, toId?) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pricePlanRequestsService.deleteRelationPricePlanPreferences(pricePlanId, fromId, toId)
      .then((programData) => {
        this.pricePlanAlertsService.updatePreferencesSuccess();
        deferred.resolve(programData);
      })
      .catch((error) => {
        this.$log.error(error);
        this.pricePlanAlertsService.updatePreferencesError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .service('PricePlanService', PricePlanService);
